import type { ReactNode } from 'react';

/**
 * Mockup `.card`: white surface, radius `--m-r-lg`, soft shadow, 20px padding.
 * Pass `className` to override padding (e.g. `p-0` for tables/lists that draw
 * their own internal padding).
 */
export function Card({ className = '', children }: { className?: string; children: ReactNode }): JSX.Element {
  return (
    <div className={`rounded-[var(--m-r-lg)] bg-[var(--m-surface)] p-5 shadow-[var(--m-shadow-sm)] ${className}`}>
      {children}
    </div>
  );
}
